import * as React from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { Form, Label } from "semantic-ui-react";

import { CustomerCategoryFormModel } from "../model";

interface CustomerCategoryFormProps {
    register: UseFormRegister<CustomerCategoryFormModel>;
    errors: FieldErrors<CustomerCategoryFormModel>;
}

export const CustomerCategoryForm: React.FunctionComponent<CustomerCategoryFormProps> = ({ errors, register }) => {
    return (
        <Form.Field>
            <label>Name</label>
            <input {...register("name")} />
            {errors.name?.message
                && (<Label pointing="above" color="red">{errors.name.message}</Label>)
            }
        </Form.Field>
    );
};
